module.exports = "Ending\n\n# Announce Winners\n\n## Content\n\n### C'est l'heure d'annoncer les gagnants!\n\n#### Les agents de formation peuvent remettre les certificats.\n\n## Notes\n&nbsp;\n\n\n# Planet Protectors\n\n## Content\n\n### Vous êtes maintenant des superhéros pour la protection de la planète!\n\n#### Félicitations!\n\nContinuez de protéger la planète et de trouver des moyens d'économiser l'eau.\n\nÀ la prochaine! La gardienne Esmeralda et Goober vous saluent!\n\n## Notes\n&nbsp;\n\n\n# All Levels Completed\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/95_ending/ending.fr_CA.md
// module id = 1713
// module chunks = 2